export default {
  failed: {
    subtitle: {
      system_error:
        'Ha ocurrido un error. <br /> Por favor inténtalo de nuevo mas tarde. <br /> Comunícate con nosotros vía Whatsapp al 50433007373 para ser asistido',
      invoice_error:
        'Has superado tu límite de crédito permitidos, puedes completar tu compra pagando con tarjeta. <br/> Comunícate con nosotros vía Whatsapp al 50433007373 para ser asistido'
    }
  }
}
